import { render, staticRenderFns } from "./articleInfo.vue?vue&type=template&id=6977f3ed&scoped=true"
import script from "./articleInfo.vue?vue&type=script&lang=js"
export * from "./articleInfo.vue?vue&type=script&lang=js"
import style0 from "./articleInfo.vue?vue&type=style&index=0&id=6977f3ed&prod&lang=css"
import style1 from "./articleInfo.vue?vue&type=style&index=1&id=6977f3ed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6977f3ed",
  null
  
)

export default component.exports